var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.content)?_c('el-tooltip',{attrs:{"effect":"dark","placement":"top","content":_vm.content}},[_c('i',{staticClass:"el-icon-question tool-tips-icon"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }